import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiCalendar, FiHome, FiLogOut, FiUser } from "react-icons/fi";
import { PiDog } from "react-icons/pi";
import { GiConfirmed } from "react-icons/gi";
import { OwnerContext } from "../../context/OwnerContext";
import '../../styles/MobileSidebar.css';

const MobileOwnerSidebar = () => {
    const navigate = useNavigate();
    const { owner } = useContext(OwnerContext);

    // Same display name logic as in OwnerSidebar
    const displayName = owner?.firstName && owner?.lastName
        ? `${owner.firstName} ${owner.lastName}`
        : owner?.username || 'Owner';

    const handleLogout = () => {
        // Clean up authentication
        localStorage.removeItem('jwt');

        // Close the mobile sidebar and remove backdrop (same logic as navigateTo)
        const mobileSidebar = document.querySelector('.mobile-sidebar');
        const backdrop = document.querySelector('.sidebar-backdrop');

        if (mobileSidebar) {
            mobileSidebar.classList.remove('open');
        }

        if (backdrop) {
            backdrop.remove();
        }

        // Navigate to home page
        navigate('/');
    };

    const navigateTo = (path) => {
        navigate(path);
        // Find and close the sidebar
        const mobileSidebar = document.querySelector('.mobile-sidebar');
        const backdrop = document.querySelector('.sidebar-backdrop');

        if (mobileSidebar) {
            mobileSidebar.classList.remove('open');
        }

        if (backdrop) {
            backdrop.remove();
        }
    };

    return (
        <>
            {/* Mobile Sidebar - no hamburger button here anymore */}
            <div className="mobile-sidebar">
                <div className="profile-section">
                    <div className="profile-icon">
                        <span>{displayName.charAt(0)}</span>
                    </div>
                    <p>{displayName}</p>
                </div>

                <nav className="nav-section">
                    <ul>
                        <li>
                            <button className="nav-button" onClick={() => navigateTo('/owner/dashboard')}>
                                <FiHome /> Dashboard
                            </button>
                        </li>
                        <li>
                            <button className="nav-button" onClick={() => navigateTo('/owner/my-dog')} data-onboarding="my-dog">
                                <PiDog /> Mój pupil
                            </button>
                        </li>
                        <li>
                            <button className="nav-button" onClick={() => navigateTo('/owner/trainings')}>
                                <GiConfirmed /> Moje treningi
                            </button>
                        </li>
                        <li>
                            <button className="nav-button" onClick={() => navigateTo('/owner/calendar')} data-onboarding="calendar">
                                <FiCalendar /> Zapisy
                            </button>
                        </li>
                        <li>
                            <button className="nav-button" onClick={() => navigateTo('/owner/account')} data-onboarding="my-account">
                                <FiUser /> Moje konto
                            </button>
                        </li>
                    </ul>
                </nav>

                <button className="logout-button" onClick={handleLogout}>
                    <FiLogOut className="logout-icon" /> Wyloguj się
                </button>
            </div>
        </>
    );
};

export default MobileOwnerSidebar;